import { Logger, LogLevel } from "../util/log/Logger";
import { BalanceHandler } from "./balance/BalanceHandler";
import { AppCore } from "./core/AppCore";
import { AppParameters } from "./core/AppParameters";
import { ProgressiveJackpotHandler } from "./jackpot/ProgressiveJackpotHandler";
import { RealityCheckTimeoutHandler } from "./realitycheck/RealityCheckTimeoutHandler";
import { GetSettingsHandler } from "./responsiblegaming/GetSettingsHandler";
import { SetSettingsHandler } from "./responsiblegaming/SetSettingsHandler";
import { SetTriggerHandler } from "./responsiblegaming/SetTriggerHandler";
/**
 * Api.ts
 */
export class Api {
    static initialise(params) {
        Logger.setLogLevel(LogLevel.DEBUG);
        Logger.logo(Api.VERSION);
        let core = AppCore.getInstance();
        let parameters = new AppParameters(params.getPrimaryNode(), params.getDeviceType());
        core.initialise(parameters);
    }
    static getBalance(action, scope, refresh = false) {
        new BalanceHandler(action, scope, refresh);
    }
    static getJackpots(params, handler, scope) {
        new ProgressiveJackpotHandler(params, handler, scope).run();
    }
    static refreshRealityCheck() {
        this.realityCheckHandler.refresh();
    }
    static onRealityCheckTimeout(winLossEnabled, action, scope) {
        this.realityCheckHandler.onRealityCheckTimeout(winLossEnabled, action, scope);
    }
    static onRealityCheckRefresh(action, scope) {
        this.realityCheckHandler.onRealityCheckRefresh(action, scope);
    }
    static getResponsibleGamingSettings(params, action, scope) {
        new GetSettingsHandler(params, action, scope).run();
    }
    static setResponsibleGamingSettings(params, action, scope) {
        new SetSettingsHandler(params, action, scope).run();
    }
    static setResponsibleGamingTrigger(params, action, scope) {
        new SetTriggerHandler(params, action, scope).run();
    }
}
Api.VERSION = "<%- version %>";
Api.realityCheckHandler = new RealityCheckTimeoutHandler();
//# sourceMappingURL=Api.js.map